import React, { useEffect, useState } from 'react'
import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import decorationtop from '../assets/svg/homepage-decor-top.svg'

const Loading: React.FC = () => {
  const [dots, setDots] = useState('')
  const { t, ready } = useTranslation(undefined, {
    useSuspense: false,
  })
  const text = ready ? t('common.loading') : 'Loading'

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => (prevDots === '.......' ? '' : `${prevDots}.`))
    }, 250)
    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <div className="w-full h-full flex justify-center items-center relative dark:bg-primary overflow-hidden">
      <img
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-150 md:scale-100 opacity-25 z-[0]"
        src={decorationtop}
        alt="decoration"
      />

      <div className="flex items-center">
        <Typography variant="h3" color="white">
          {text}
        </Typography>
        <Typography variant="h3" color="white">
          {dots}
        </Typography>
      </div>
    </div>
  )
}

export default Loading
